const mutations = {
  async UPDATE_APP_SETTINGS(state, payload) {
    state.appSettings = payload;
    await localStorage.setItem(
      "appSettings",
      JSON.stringify(payload.fixedPaySetup)
    );
  },
  UPDATE_STATE_FROM_LOCALSTORAGE(state) {
    state.$simpleAuthHeader.headers.authorization = localStorage.getItem(
      "token"
    );
    state.token = localStorage.getItem("token");
    state.linchpin = JSON.parse(localStorage.getItem("linchpin"));
  },

  UPDATE_LOCALSTORAGE_WITH_LINCHPIN(state, payload) {
    localStorage.removeItem("linchpin");
    localStorage.setItem("linchpin", JSON.stringify(payload));
  },
  UPDATE_SIDENAV_STATE(state) {
    state.isSideNavCollapsed = !state.isSideNavCollapsed;
  },
  RESET_USER_LIST() {
    localStorage.removeItem("users");
  },
  RESET_ALL_GROUPS() {
    localStorage.removeItem("functionalGroups");
    localStorage.removeItem("projectsGroups");
    localStorage.removeItem("managementGroups");
    localStorage.removeItem("groupNames");
  },
  SET_TOAST_OPTIONS(state, payload) {
    state.toastOptions = payload;
  },
  RESET_TOAST(state) {
    // console.log("reset called");
    state.toastOptions = {
      display: false,
      description: "Success",
      type: "success",
      title: "Success",
    };
  },
  SET_BUSINESS_DETAILS(state, payload) {
    state.businessDetails = payload;
  },
  saveBusinessDetails({ commit }, data) {
    commit("SET_BUSINESS_DETAILS", data);
  }
};
export default mutations;
